import React from 'react';

export const formatPercent = ({ value }) => {
  if (value < 1) return <span>{(value * 100).toLocaleString()} %</span>;

  return formatEuro({ value });
};

export const formatEuro = ({ value }) => {
  if (value != null) return <span>{value.toLocaleString()} €</span>;

  return '';
};

export const formatDate = ({ value }) => {
  if (value){
    let date = new Date(value*1000);
    let string = date.getDate().toString().padStart(2, "0")+"/"+(date.getMonth()+1).toString().padStart(2, "0")+"/"+date.getFullYear();
    return string;
  }

  return '';
};


// WEBPACK FOOTER //
// ./src/Components/DataGrid/Format.js